import React from 'react';

import { styled, StyleSheet } from '@rexlabs/styling';
import { FormRenderer as RexlabsFormRenderer } from '@rexlabs/form-renderer';
import Box from '@rexlabs/box';
import { Form as RexlabsForm } from '@rexlabs/form';
import { PrimaryButton } from '../button';

const defaultStyles = StyleSheet({
  formDescription: {
    marginBottom: '1.6rem',
    fontColor: '#000',
    fontWeight: 400,
    fontSize: '1.4rem',
    fontHeight: '1.6rem'
  },
  brand: {
    background: 'var(--brand_primary_color)',
    borderColor: 'var(--brand_primary_color)',
    color: 'var(--brand_contrast_color)',
    textDecoration: 'none',
    ':hover': {
      background: 'var(--brand_primary_color)',
      borderColor: 'var(--brand_primary_color)',
      color: 'var(--brand_contrast_color)',
      opacity: 0.85
    },
    ':active': {
      background: 'var(--brand_primary_color)',
      borderColor: 'var(--brand_primary_color)',
      color: 'var(--brand_contrast_color)',
      opacity: 0.75
    }
  }
});

function FormRenderer({ styles: s, submitting, ...formProps }) {
  return (
    <RexlabsFormRenderer {...formProps}>
      {({ normalizedFields, form, schema }) => {
        return (
          <RexlabsForm>
            <Box flexDirection={'column'}>
              <Box className='form-title'>
                <h3 className='h3'>{schema?.definition?.label}</h3>
              </Box>
              {schema?.definition?.description && (
                <span {...s('formDescription')}>
                  {schema?.definition?.description}
                </span>
              )}
            </Box>

            <Box className='v2-form-fields-container' mb={'1.2rem'}>
              {normalizedFields.default.no_group.map(
                ({ fieldProps, Field }, index) => (
                  <Box key={index} className='v2-form-field'>
                    <Field key={index} {...fieldProps} />
                  </Box>
                )
              )}
            </Box>

            <PrimaryButton
              {...s('brand')}
              onClick={form.submitForm}
              isLoading={submitting}
            >
              Submit
            </PrimaryButton>
          </RexlabsForm>
        );
      }}
    </RexlabsFormRenderer>
  );
}

export default styled(defaultStyles)(FormRenderer);
